<template>
  <div class="col mb-4" :class="theClass" :style="theStyle">
    <div class="card" :class="cardClass">
      <h4 v-if="title" class="card-header">
        {{ title }} <small>{{ subtitle }}</small>
        <b-button v-if="idCollapse" v-b-toggle="idCollapse" class="m-1">
          <i class="fa fa-angle-double-down"></i>
        </b-button>
        <router-link to="ecommercesNew" class="buttonNew btn btn-primary" v-if="buttonNew" >
            Novo
        </router-link>
        <div v-if="select || select2 || select3 || validationSelect || validationSelect2" class="selects">
          <select
            v-if="select"
            @change="onselect"
            v-model="selected"
            class="form-control"
            name=""
          >
            <option
              v-for="item in select"
              :value="item.id"
              :key="item.id"
              :selected="item.id"
            >
              {{ item.name }} {{ item.selected }}
            </option>
          </select>
          <select
            v-if="select2"
            @change="onselect2"
            v-model="selected2"
            class="form-control"
            name=""
          >
            <option
              v-for="item in select2"
              :value="item.id"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }} {{ item.selected }}
            </option>
          </select>
          <select
            v-if="select3"
            @change="onselect3"
            v-model="selected3"
            class="form-control"
            name=""
          >
            <option
              v-for="item in select3"
              :value="item.id"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }} {{ item.selected }}
            </option>
          </select>
          <select
            v-if="validationSelect"
            @change="onValidationSelect"
            v-model="validationSelected"
            class="form-control"
            name=""
          >
            <option
              v-for="item in validationSelect"
              :value="item.id"
              :key="item.id"
              :selected="item.id"
            >
              {{ item.name }} {{ item.selected }}
            </option>
          </select>
          <select
            v-if="validationSelect2"
            @change="onValidationSelect2"
            v-model="validationSelected2"
            class="form-control"
            name=""
          >
            <option
              v-for="item in validationSelect2"
              :value="item.id"
              :key="item.id"
              :selected="item.id"
            >
              {{ item.name }} {{ item.selected }}
            </option>
          </select>
        </div>
      </h4>
      <div v-if="block" class="card-block">
        <slot></slot>
      </div>
      <slot v-else></slot>
      <div v-if="loading" class="card-loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    select: Array,
    select2: Array,
    select3: Array,
    validationSelect: Array,
    validationSelect2: Array,
    title: String,
    subtitle: String,
    block: {
      default: true
    },
    col: {
      default: 4
    },
    offset: {
      default: null
    },
    idCollapse: String,
    buttonNew: String,
    loading: Boolean,
    mw: String,
    cardClass: String
  },
  data () {
    return {
    }
  },
  computed: {
    selected: {
      get () {
        return this.$store.state.selected
      },
      set (value) {
        this.$store.dispatch('setSelected', value)
      }
    },
    selected2: {
      get () {
        return this.$store.state.selected2
      },
      set (value) {
        this.$store.dispatch('setSelected2', value)
      }
    },
    selected3: {
      get () {
        return this.$store.state.selected3
      },
      set (value) {
        this.$store.dispatch('setSelected3', value)
      }
    },
    validationSelected: {
      get () {
        return this.$store.state.validationSelected
      },
      set (value) {
        this.$store.dispatch('setValidationSelected', value)
      }
    },
    validationSelected2: {
      get () {
        return this.$store.state.validationSelected2
      },
      set (value) {
        this.$store.dispatch('setValidationSelected2', value)
      }
    },
    theStyle: function () {
      if (this.mw) {
        return 'max-width: ' + this.mw + ';'
      }
    },
    theClass: function () {
      var col = this.col
      var type = typeof col
      var value = ''

      if (type === 'string') {
        value = 'col-md-' + col
      } else if (type === 'object') {
        for (var index in col) {
          if (index === 'xs') {
            value += 'col-' + col[index] + ' '
          } else {
            value += 'col-' + index + '-' + col[index] + ' '
          }
        }
      }

      var offset = this.offset
      if (offset) {
        var typeOffset = typeof offset
        if (typeOffset === 'number') {
          value += 'offset-md-' + offset
        } else {
          for (var idx in offset) {
            if (idx === 'xs') {
              value += 'offset-' + offset[idx] + ' '
            } else {
              value += 'offset-' + idx + '-' + offset[idx] + ' '
            }
          }
        }
      }
      return value
    }
  },
  methods: {
    onselect (e) {
      // alert(this.selected)
      this.$emit('onselect', this.selected)
      // console.log("CARD " + this.selected);
    },
    onselect2 () {
      // alert(this.selected)
      this.$emit('onselect2', this.selected2)
    },
    onselect3 () {
      // alert(this.selected)
      this.$emit('onselect3', this.selected3)
    },
    onValidationSelect () {
      this.$emit('onValidationSelect', this.validationSelected)
    },
    onValidationSelect2 () {
      this.$emit('onValidationSelect2', this.validationSelected2)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "../../../assets/scss/mixins.scss";
@import "../../../assets/scss/card.scss";

/* .col-card {
  // margin-bottom: 30px;
} */

h4 {
  display: flex;
  justify-content: space-between;
}

.selects {
  margin-top: 3px;
}

.card-loader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  z-index: 998;

  &:before {
    content: "";
    display: block;
    border: 6px solid rgba(0, 0, 0, 0.05);
    border-top: 6px solid #72e977;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: card-loader-spin 2s linear infinite;
  }
  &:after {
    content: "Carregando";
  }
}
@keyframes card-loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/card/Card.vue